module.exports = __webpack_public_path__ + "static/3.f770d74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slider/3.png
// module id = 447
// module chunks = 35783957827783